export interface DevInfo {
    isBeta: boolean;
    isProduction: boolean;
    svn: {
        branch: string;
        revision: number;
    };
    dbInfo: {
        configuration: string;
        shard: string;
    };
    betaNumber: string;
    clientId: string;
    role: string;
    operatorFeatures: string[];
    clientFeatures: string[];
}

export interface ClientDevData {
    clientId: string;
    configuration: string;
    shard: string;
    role: string;
    operatorLogin: string;
    uid: string;
    operatorFeatures: string[];
    clientFeatures: string[];
}

export enum DevelopmentToolsActionType {
    showCaptcha = 'do_not_show_captcha',
    fakeAuth = 'fake_name',
    dumpVars = 'dumpvars_into_json',
    features = 'features'
}

export enum DevelopmentCookieState {
    ACTIVE = '1'
}

export interface FakeAuthData {
    fakeName: string;
    uid: string;
}
